import { render, staticRenderFns } from "./pageFlag.vue?vue&type=template&id=f20a77fe&"
import script from "./pageFlag.vue?vue&type=script&lang=js&"
export * from "./pageFlag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports